import InitAnalytics from "./init-analytics";

export default InitAnalytics;
